import React from "react";
import { Table, Select } from "antd";
import { Btn } from "../../../AbstractElements";
import { getFullCourseName } from "../../../utils/course";
import { sendEmail } from "./EmailHandler";

const { Option } = Select;

const StudentTable = ({ students, loading,  onOpenDetails, setDetailsModel, courses, search }) => {
  const filteredStudents = students.filter(student => {
    const fullName = student.fullName?.toLowerCase() || "";
    const email = student.email?.toLowerCase() || "";
    return fullName.includes(search.toLowerCase().trim()) || email.includes(search.toLowerCase().trim());
  });

  const getDropBtnLabel = (courseId) => {
    const course = courses.find(course => course.id === courseId);
    return course ? getFullCourseName(course) : "Not Enrolled";
  };



  const userTableColumnRow = [
    { title: "STUDENT ID", dataIndex: "studentId", sorter: (a, b) => parseFloat(a.studentId) - parseFloat(b.studentId) },
    {
      title: "NAME",
      dataIndex: "fullName",
      render: text => text?.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" "),
      sorter: (a, b) => a.fullName.localeCompare(b.fullName),
    },
    { title: "EMAIL", dataIndex: "email", sorter: (a, b) => a.email.localeCompare(b.email) },
    {
      title: "CURRENT COURSE",
      render: (text, record) => (
        <Select value={getDropBtnLabel(record?.courses[record?.courseIndex]?.courseId)} disabled>
          {courses.map(course => (
            <Option key={course.id} value={course.id}>{getFullCourseName(course)}</Option>
          ))}
        </Select>
      ),
    },
    { title: "SEND EMAIL", render: (text, record) => <Btn attrBtn={{ color: "primary", onClick: () => sendEmail(record.email) }}>Send</Btn> },
    { 
      title: "DETAILS", 
      render: (text, record) => (
        <Btn attrBtn={{ color: "primary", onClick: () => setDetailsModel({show :true ,details:record}) }}>
          Details
        </Btn>
      ) 
    }
  ];

  return <Table loading={loading} columns={userTableColumnRow} dataSource={filteredStudents} scroll={{ x: "auto" }} bordered pagination />;
};

export default StudentTable;